export default __webpack_public_path__ + "static/media/litho-demo-freelancer.9f338134.jpg";